/**
 * appVersion — the dview-lite BROWSER-APP version, surfaced across every product
 * line (local dview / eview / cloud). It is DISTINCT from:
 *   - the NVR/DVS version (that's the appliance, shown as "DVS v…" in StatusView), and
 *   - the cloud API version (that's cloudapi: the /ve/login payload, then each
 *     response's X-Cloudapi-Version — see CloudNvrAdapter.getBackendVersion()).
 * It cannot tell two builds apart (cloud deploys do not bump it, and every
 * non-release NVR build is "dev"); scripts/write-build-meta.js names each build.
 *
 * Source of truth = the in-source constant below (YYYY.M.patch), bumped per lite release.
 * It lives here — not in .env or package.json — because ALL `dview/lite/.env*` are gitignored
 * (.gitignore) and CRA forbids importing package.json from outside src/, so a tracked env value
 * would never ship. A build-time REACT_APP_VERSION (docker/release pipeline) still OVERRIDES it
 * when set. Bump this constant on each lite release. #86bb7phhh (David 2026-08-17).
 */
export const APP_VERSION = process.env.REACT_APP_VERSION || '2026.11.1';

/*
 * Two meanings of the same number (ADR-183). In the cloud (release nvrcloud,
 * cloudnvr/ tags) it is the web release above. On an NVR box, lite is part of
 * that NVR release: the NVR viewer build always sets REACT_APP_VERSION, to the
 * release version V on a release candidate or "dev" otherwise, so this cloud
 * literal never leaks onto a box.
 */
/** "v2026.9.5" for a numeric version, "dev" as is. */
export const APP_VERSION_LABEL = /^\d/.test(APP_VERSION) ? `v${APP_VERSION}` : APP_VERSION;
